import React from "react";
import { LPMUKP } from "./LPMUKP";
const Pegawai = React.lazy(() => import('./pegawai'));
const Produksi = React.lazy(() => import('./produksi'));
const Keuangan = React.lazy(() => import('./keuangan'));
const Valnas = React.lazy(() => import('./valnas'));
const Renja = React.lazy(() => import('./renja'));
const PHLN = React.lazy(() => import('./perencanaan/phln'));
const PHukum = React.lazy(() => import('./hukum/peraturanhukum'));
const RealDanRenKeu = React.lazy(() => import('./RealisasiDanRencanaKeuangan'));
const TabContainer = React.lazy(() => import('./TabContainer/index'));

export const dashMstrPageConfig = [
    {
        path: '/new-dash/pegawai',
        element: <Pegawai />
    },
    {
        path: '/new-dash/lpmukp',
        element: <LPMUKP />,
        roleAccess: ['LPMUKP_DASHBOARD']
    },
    {
        path: '/new-dash/produksi',
        element: <Produksi />
    },
    {
        path: '/new-dash/keuangan',
        element: <Keuangan />
    },
    {
        path: '/new-dash/valnas',
        element: <Valnas />
    },
    {
        path: '/new-dash/renja',
        element: <Renja />
    },
    {
        path: '/new-dash/phln',
        element: <PHLN />
    },
    {
        path: '/new-dash/phukum',
        element: <PHukum />
    },
    {
        path: '/new-dash/drealdanren',
        element: <RealDanRenKeu />
    },
    {
        path: '/new-dash/tab/:type',
        element: <TabContainer />,
        roleAccess: [
            // role dashboard
            'D_KK',
            'D_KP',
            'D_BPEM',
            // role dashboard pengetahuan
            'MP.PNL',
            'PNL.SES.BKIPMKHP',
            'PNL.SES.BRSDM',
            'PNL.SES.DJPB',
            'PNL.SES.DJPDSPKP',
            'PNL.SES.DJPRL',
            'PNL.SES.DJPSDKP',
            'PNL.SES.DJPT',
            'PNL.SES.IJ',
            'PNL.SES.PSD',
            'PNL.SES.SEKJEN'
        ]
    }
];